"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sellerType = void 0;
const types_1 = require("../../types");
exports.sellerType = [
    {
        name: 'Private',
        value: types_1.Vehicle.SellerTypeEnum.Private,
    },
    {
        name: 'Dealer',
        value: types_1.Vehicle.SellerTypeEnum.Dealer,
    },
];
